import { render } from "./ContactUs.vue?vue&type=template&id=bc9082b6&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=bc9082b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bc9082b6"

export default script